export enum AppStoreDetailsActionTypes {
  CHANGE_READY_TO_GO_LIVE_INTEGRATIONS = 'CHANGE_READY_TO_GO_LIVE_INTEGRATIONS',
  CHANGE_APP_STORE_DETAILS = 'CHANGE_APP_STORE_DETAILS',
  CHANGE_INTEGRATIONS_WITH_GO_LIVE_STATUSES = 'CHANGE_INTEGRATIONS_WITH_GO_LIVE_STATUSES',
}
